import * as dataAccess from 'app/utils/ajax';
import { API_CONSTANTS } from 'app/constants/api-contants';
import { fetchData } from './comonsearch';

export const getOfferList = async (param) => {
  const baseUrl = `${API_CONSTANTS.OFFER}/list`;
  let responseObj = await fetchData(baseUrl, param);
  return responseObj;
};

export const addOffer = async (incomingData) => {
  let payload = {
    data: {
      ...incomingData,
    },
  };

  let responseObj = await dataAccess.post(
    `${API_CONSTANTS.OFFER}/add`,
    payload
  );

  return responseObj;
};

export const deleteOffer = async (id) => {
  let url = `${API_CONSTANTS.OFFER}/delete?offerDetailId=${id}`;

  let responseObj = await dataAccess.del(url);
  return responseObj;
};

export const updateOffer = async (id, incomingData) => {
  let url = '';
  url = `${API_CONSTANTS.OFFER}/update?offerDetailId=${id}`;

  let payload = {
    data: {
      ...incomingData,
    },
  };

  let responseObj = await dataAccess.put(url, payload);
  return responseObj;
};

export const getOfferById = async (id) => {
  let url = `${API_CONSTANTS.OFFER}/detail?offerDetailId=${id}`;
  let responseObj = await dataAccess.get(url);
  return responseObj;
};

export async function uplaodBannerMedia(file) {
  let formData = new FormData();
  formData.append('image', file);
  let payload = {
    data: formData,
  };

  let responseObj = await dataAccess.upload(
    `${API_CONSTANTS.MEDIA_UPLOAD}`,
    payload
  );

  return responseObj;
}

export const getTemplate = async () => {
  let responseObj = await dataAccess.get(`${API_CONSTANTS.OFFER}/template`);
  return responseObj;
};
